<template>
  <div>
    <h2 class="step-name">Beef</h2>

    <div class="step-section">
      <h3>
        <span class="form-group">
          Reproduction - MA Cattle
          <comments field-name="reproduction_ma_cattle"></comments>
        </span>
      </h3>

      <div class="row">
        <div class="col-md-6">
          <h3>Last season</h3>
          <div class="form-group input-box">
            <label>Planned Start of Mating</label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').beef_ma_planned_start_mating"
              disabled
            />
          </div>
          <div class="form-group input-box">
            <label>Calculated Start of Calving</label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').beef_ma_calc_start_of_calving"
              disabled
            />
          </div>
        </div>

        <div class="col-md-6">
          <h3>This season</h3>
          <date-input
            field-name="beef_ma_planned_start_mating"
            label="Planned Start of Mating"
            @on-change="calculateStartOfCalving"
          >
          </date-input>

          <date-input
            label="Calculated Start of Calving"
            field-name="beef_ma_calc_start_of_calving"
            :min-date="this.getFieldValue('beef_ma_planned_start_mating')"
          >
          </date-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h3>Last season</h3>
          <div class="form-group input-box">
            <label>Percent Scanning</label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').beef_ma_scanning_percent"
              disabled
            />
          </div>
          <div class="form-group input-box">
            <label>Percent Weaning</label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').beef_ma_weaning_percent"
              disabled
            />
          </div>
        </div>

        <div class="col-md-6">
          <h3>This season</h3>
          <number-input label="Percent Scanning" field-name="beef_ma_scanning_percent"> </number-input>
          <number-input label="Percent Weaning" field-name="beef_ma_weaning_percent"> </number-input>
        </div>
      </div>
    </div>

    <div class="step-section">
      <h3>
        <span class="form-group">
          Reproduction - Heifers
          <comments field-name="reproduction_heifers"></comments>
        </span>
      </h3>

      <div class="row">
        <div class="col-md-6">
          <h3>Last season</h3>
          <div class="form-group input-box">
            <label>Planned Start of Mating</label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').beef_heifer_planned_start_mating"
              disabled
            />
          </div>
          <div class="form-group input-box">
            <label>Calculated Start of Calving</label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').beef_heifer_calc_start_of_calving"
              disabled
            />
          </div>
        </div>

        <div class="col-md-6">
          <h3>This season</h3>
          <date-input
            field-name="beef_heifer_planned_start_mating"
            label="Planned Start of Mating"
            @on-change="calculateStartOfHeiferCalving"
          >
          </date-input>

          <date-input
            label="Calculated Start of Calving"
            field-name="beef_heifer_calc_start_of_calving"
            :min-date="this.getFieldValue('beef_heifer_planned_start_mating')"
          >
          </date-input>

          <radio-input
            label="Age of First Calving Heifers"
            field-name="beef_first_calving_heifers_age"
            :choices="[
              { value: 'R2', display: 'R2' },
              { value: 'R3', display: 'R3' },
            ]"
          >
          </radio-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h3>Last season</h3>
          <div class="form-group input-box">
            <label>Percent Scanning</label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').beef_hef_scanning_percent"
              disabled
            />
          </div>
          <div class="form-group input-box">
            <label>Percent Weaning</label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').beef_hef_weaning_percent"
              disabled
            />
          </div>
        </div>

        <div class="col-md-6">
          <h3>This season</h3>
          <number-input label="Percent Scanning" field-name="beef_hef_scanning_percent"> </number-input>
          <number-input label="Percent Weaning" field-name="beef_hef_weaning_percent"> </number-input>
        </div>
      </div>
    </div>

    <div class="step-section">
      <h3>Scanning Questions</h3>

      <radio-input
        label="Use VetSouth?"
        field-name="beef_wants_scanning_vs"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <radio-input
        label="Pregnancies aged?"
        field-name="beef_are_pregs_aged"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <date-input field-name="beef_expected_scanning_date" label="Expected scanning date"> </date-input>
    </div>

    <div class="step-section">
      <h3>
        <span class="form-group">
          Reproduction Programs
          <comments field-name="reproduction_programs"></comments>
        </span>
      </h3>

      <radio-input
        label="Are you interested in Repro programs"
        :add-email-notification="true"
        field-name="beef_wants_repro_programs"
        @on-change="toggleNotification"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <radio-input
        label="Bull fertility testing"
        field-name="beef_wants_bull_fertility_testing"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
          { value: 'Maybe', display: 'Maybe' },
        ]"
      >
      </radio-input>
    </div>

    <div class="step-section">
      <discussion-points
        title="Reproduction General Comments"
        comments-field="reproduction_general_comments"
        points="Target, Calves, Bulls, Condition, Mating"
      >
      </discussion-points>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'Beef',
  mixins: [baseComponent],
  methods: {
    calculateStartOfCalving: function ({ value }) {
      this.setFieldValue({
        modelName: this.$options.name,
        fieldName: 'beef_ma_calc_start_of_calving',
        value: this.$moment(value).add(283, 'days').format('YYYY-MM-DD'),
      })
    },
    calculateStartOfHeiferCalving: function ({ value }) {
      this.setFieldValue({
        modelName: this.$options.name,
        fieldName: 'beef_heifer_calc_start_of_calving',
        value: this.$moment(value).add(283, 'days').format('YYYY-MM-DD'),
      })
    },
    toggleNotification: function ({ fieldName, value }) {
      if (fieldName == 'beef_wants_repro_programs') {
        this.setEmailNotification({ slug: 'interested-in-repro-programs', value: value == 'Yes' ? true : false })
      }
    },
  },
}
</script>
